import React, { useState, useEffect } from "react";
import Popup from "reactjs-popup";
import DayPicker from "react-day-picker";

import { toastSuccess, toastError } from "../../../shared/toastHelper";

const axios = require('axios').default;

const popupContentStyle = {
  border: "none",
  borderRadius: "8px",
  boxShadow: "0 0 1px 1px rgba(0,0,0,0.02), 0 4px 6px 1px rgba(0,0,0,0.06)",
  padding: "0px",
  background: "var(--od-surface, #fff)",
  width: "fit-content",
  maxWidth: "320px",
};

const selectedDateStyle = {
  border: "1px solid var(--od-c-e0e0e0, #E0E0E0)",
  borderRadius: "8px",
  padding: "5px 10px",
  width: "65%",
};

const todayButtonStyle = {
  border: "1px solid var(--od-c-e0e0e0, #E0E0E0)",
  borderRadius: "8px",
  padding: "7px 10px",
  width: "30%",
  backgroundColor: "var(--od-c-ffffff, white)",
};

const cancelButtonStyle = {
  backgroundColor: "var(--od-c-ffffff, white)",
  width: "48%",
  padding: "7px 10px",
  borderWidth: "1px",
  borderColor: "var(--od-c-e0e0e0, #E0E0E0)",
};

const selectButtonStyle = {
  color: "white",
  width: "47%",
  padding: "7px 10px",
  borderWidth: "1px",
};

const clearButtonStyle = {
  backgroundColor: "#F31B28",
  width: "100%",
  padding: "7px 10px",
  borderRadius: "8px",
  borderWidth: "1px",
  borderColor: "#F31B28",
  boxShadow: "none",
  color: "white",
};

const holdPickerCancelButtonStyle = {
  backgroundColor: "var(--od-c-ffffff, white)",
  width: "100%",
  padding: "7px 10px",
  borderWidth: "1px",
  borderColor: "var(--od-c-e0e0e0, #E0E0E0)",
  borderRadius: "8px",
  boxShadow: "none",
};

const holdPickerContainerStyle = {
  maxHeight: "250px",
  overflowY: "scroll",
  width: "100%",
  display: "flex",
  flexDirection: "column",
  gap: "10px",
};

const holdPositionRowStyle = {
  display: "flex",
  alignItems: "center",
  gap: "10px",
  width: "100%",
  cursor: "pointer",
};

const holdPositionStyle = {
  padding: "2px 3px",
  borderRadius: "4px",
  fontSize: "10px",
  fontWeight: "bold",
  color: "var(--od-c-333333, #333)"
}

const ClearHoldsPopup = ({
  csrfToken,
  user,
  team,
  showClearHoldsPopup,
  setShowClearHoldsPopup,
  selectedRooms,
  selectedTags,
  fetchCalendarEventsForSelectedVenues,
  currentCalendarDate,
}) => {
  const [month, setMonth] = useState(currentCalendarDate);
  const [date, setDate] = useState(currentCalendarDate);
  const [tab, setTab] = useState("datePicker");
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [holdPositions, setHoldPositions] = useState([]);
  const [selectedHoldPositionIds, setSelectedHoldPositionIds] = useState([]);

  useEffect(() => {
    if (currentCalendarDate) {
      setMonth(currentCalendarDate);
      setDate(currentCalendarDate);
    }
  }, [currentCalendarDate]);

  useEffect(() => {
    if (tab === "holdPicker") {
      setIsLoading(true);

      const startOfDay = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0);
      const endOfDay = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59, 999);

      const ransackParams = [
        `q[start_time_gteq]=${startOfDay.toISOString()}`,
        `q[start_time_lteq]=${endOfDay.toISOString()}`,
        `q[clearable]=true`,
        `q[calendar_event_calendar_classification_eq]=hold`,
      ];

      axios.defaults.headers.common["X-CSRF-TOKEN"] = csrfToken;
      axios.get(`/teams/${team.id}/hold_positions?${ransackParams.join("&")}`)
        .then((response) => {
          setHoldPositions(response.data);
          setSelectedHoldPositionIds(response.data.map((holdPosition) => holdPosition.id));
          setIsLoading(false);
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }, [tab])

  const toggleHoldPosition = (holdPositionId) => {
    setSelectedHoldPositionIds(selectedHoldPositionIds.includes(holdPositionId) ?
      selectedHoldPositionIds.filter((id) => id !== holdPositionId) :
      [...selectedHoldPositionIds, holdPositionId]);
  };

  const clearSelectedHolds = (close) => {
    setIsSubmitting(true);

    axios.defaults.headers.common["X-CSRF-TOKEN"] = csrfToken;
    axios.post(`/teams/${team.id}/hold_positions/clear_hold_positions`, {
      hold_position_ids: selectedHoldPositionIds,
    })
      .then(() => {
        toastSuccess("Selected holds cleared");
        fetchCalendarEventsForSelectedVenues(team, selectedRooms, selectedTags);
        close();
      })
      .catch((error) => {
        toastError("Failed to clear holds");
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  return (
    <Popup
      arrow={false}
      contentStyle={popupContentStyle}
      overlayStyle={{ zIndex: "3999" }}
      closeOnDocumentClick
      open={showClearHoldsPopup}
      onClose={() => {
        setShowClearHoldsPopup(false);
        setTab("datePicker");
      }}
    >
      {close => (
        <div className="d-flex flex-column align-items-center" style={{ gap: "10px", padding: "20px" }}>
          {tab === "datePicker" ? (
            <>
              <div className="d-flex justify-content-between align-items-center figma-text sm" style={{ width: "100%" }}>
                <a href="#" onClick={() => setMonth(new Date(month.getFullYear(), month.getMonth() - 1, 1))}>
                  <i className="far fa-chevron-left figma-text quinary" />
                </a>
                <div className="figma-text primary semibold">{month.toLocaleDateString("en-US", { month: "long", year: "numeric" })}</div>
                <a href="#" onClick={() => setMonth(new Date(month.getFullYear(), month.getMonth() + 1, 1))}>
                  <i className="far fa-chevron-right figma-text quinary" />
                </a>
              </div>
              <div className="d-flex justify-content-between align-items-center" style={{ width: "100%" }}>
                <div style={selectedDateStyle}>
                  {date.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" })}
                </div>
                <button className="figma-text xs tertiary semibold"
                  style={todayButtonStyle}
                  onClick={() => {
                    setDate(new Date());
                    setMonth(new Date());
                  }}
                >
                  Today
                </button>
              </div>
              <DayPicker
                className="day-picker-calendar-minimap"
                showOutsideDays={true}
                firstDayOfWeek={0}
                month={month}
                navbarElement={() => null}
                captionElement={() => null}
                selectedDays={date}
                onDayClick={(date) => {
                  setDate(date);
                }}
              />
              <div className="d-flex justify-content-between align-items-center" style={{ width: "100%" }}>
                <button
                  onClick={() => close()}
                  className="btn btn-secondary figma-text secondary sm"
                  style={cancelButtonStyle}
                >
                  Cancel
                </button>
                <button
                  onClick={() => setTab("holdPicker")}
                  className="btn btn-primary figma-text sm"
                  style={selectButtonStyle}
                >Select</button>
              </div>
            </>
          ) : (
            <>
              <div className="d-flex justify-content-between" style={{ width: "100%" }}>
                <i className="far fa-trash-can figma-text xl" style={{
                  color: "#F31B28",
                  backgroundColor: "#F31B281A",
                  padding: "12px",
                  borderRadius: "50%",
                }}/>
                <a href="#" onClick={() => close()}>
                  <i className="far fa-xmark figma-text xl quinary" />
                </a>
              </div>
              <div className="figma-text secondary semibold xl" style={{
                width: "100%",
              }}>Clear holds</div>
              <div className="figma-text quaternary sm" style={{
                textWrap: "wrap",
                maxWidth: "280px",
                marginBottom: "5px",
              }}>
                Confirm the holds you want to be clear on this date. This action cannot be undone.
              </div>
              <div className="figma-text secondary bold" style={{ width: "100%" }}>
                {date.toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" })}
              </div>
              <div style={holdPickerContainerStyle}>
                {isLoading ? (
                  <div>Loading...</div>
                ) : holdPositions.length === 0 ? (
                  <div>No holds found</div>
                ) : (
                  <>
                    {holdPositions.map((holdPosition) => (
                      <a key={holdPosition.id} style={holdPositionRowStyle} onClick={() => { toggleHoldPosition(holdPosition.id)}}>
                        <input
                          type="checkbox"
                          checked={selectedHoldPositionIds.includes(holdPosition.id)}
                          onChange={() => {}}
                        />
                        <div style={{
                          ...holdPositionStyle,
                          border: "1px solid " + holdPosition.calendar_event?.venue_ownership?.calendar_color_hex,
                        }}>
                          {"H" + holdPosition.position}
                        </div>
                        <div className="figma-text secondary xs semibold" style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                          {holdPosition.calendar_event?.title}
                        </div>
                        <div className="figma-text quinary xs" style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                          {holdPosition.room_names}
                        </div>
                      </a>
                    ))}
                  </>
                )}
              </div>
              <button
                disabled={selectedHoldPositionIds.length === 0 || isSubmitting || isLoading}
                className={`btn figma-text sm semibold ${selectedHoldPositionIds.length === 0 || isSubmitting || isLoading ? "disabled" : ""}`}
                style={clearButtonStyle}
                onClick={() => clearSelectedHolds(close)}
              >
                Clear
              </button>
              <button
                  className="btn figma-text sm secondary semibold"
                  style={holdPickerCancelButtonStyle}
                  onClick={() => setTab("datePicker")}
              >
                Cancel
              </button>
            </>
          )}
        </div>
      )}
    </Popup>
  )
};

export default ClearHoldsPopup;
